/**
 * ## Section Tab Controller
 *
 * @module src/controllers/sections
 */

"use strict";

const component = require("../../components/component");
const chart = require("../../components/chart");
const block = require("../../components/block");
const modal = require("../../components/modal");
const notification = require("../../components/notification");
const l = require("../../common").localization;

/** Init
 */
const init = (kd) => {
  // this just setup a listener to template and refresh when updated is separate
  // function, call the function at start up.

  // check that each template has a chart assignment. If not, assign current chart.

  const location = Object.assign({}, kd.doc("location")[0]);
  const templates = Object.assign(
    [],
    kd.find("template", {
      active: 1,
      chart: location.chart,
    })
  );

  for (let i = 0; i < templates.length; ++i) {
    if (!templates[i].hasOwnProperty("chart")) {
      templates[i].chart = location.chart;
      const proposed = {
        domain: "template",
        _id: templates[i]._id,
        chart: location.chart,
      };
      kd.update(proposed)
        .then((result4) => {})
        .catch((err3) => {
          console.log("err3", err3);
        });
    }
  }

  // standard setup
  const opt = {
    kd,
    targetDiv: "content_standard_sections",
  };

  const data = {
    type: "sections",
    domain: "template",
    h1: "All Parties",
    h2: "...",
    expand: true,
    single: false,
    group: "all",
    refresh: 30,
    height: {},
    status: {
      min: 1,
      max: 8,
    },
    size: {
      min: 1,
      max: 500,
    },
    waited: {
      min: 0,
      max: 2000,
    },
  };

  const buttons = [
    {
      description: l.translate("Server Assignment"),
      value: "assign",
    },
    {
      description: l.translate("Enable Section Tables"),
      value: "enable",
    },
    {
      description: l.translate("Disable Section Tables"),
      value: "disable",
    },
    {
      description: l.translate("Zoom To Section"),
      value: "zoom",
    },
  ];

  block.create(opt, data, (err, result) => {
    const options = {
      target_id: result.target_id,
      section: result.value,
      type: "buttonlist",
      position: "left",
      highlight: null,
      adjust: {
        x: 0,
        y: 25,
      },
    };

    component.create(options, buttons, (err2, value) => {
      const templatedata = Object.assign(
        {},
        kd.doc("template", location.template)[0]
      );
      switch (value.value) {
        case "assign": {
          const opt2 = {
            target_id: result.target_id,
            section: result.value,
            type: "dropdown",
            position: "left",
            highlight: null,
            adjust: {
              x: 0,
              y: 25,
            },
          };
          const servers = location.servers;
          const assignments = location.assignments;
          const serverslist = [];
          serverslist.push({
            description: `+ ${l.translate("Add New")}`,
            value: "addnew",
          });
          serverslist.push({
            description: l.translate("Clear (None)"),
            value: "clear",
          });
          servers.forEach((server) => {
            serverslist.push({
              description: server.name,
              value: server.name,
            });
          });

          component.create(opt2, serverslist, (err3, result2) => {
            if (result2.value == "addnew") {
              const opt4 = {
                width: "80%",
                type: "dialog",
                h1: l.translate("Add Server"),
                body: l.translate(
                  "Please enter the name of new server. " +
                    "The name will be added to the end of the list and can be reordered " +
                    "and managed in the dashboard area."
                ),
                fields: [
                  {
                    description: l.translate("Server Name"),
                  },
                ],
                buttons: [
                  {
                    description: l.translate("Cancel"),
                    value: "cancel",
                  },
                  {
                    description: l.translate("Add Server"),
                    value: "addServer",
                  },
                ],
              };

              const modaldata = {
                kd,
              };
              modal.create(opt4, modaldata, (modalerr, modalvalue) => {
                let pass = true;
                for (let i = 0; i < location.servers.length; ++i) {
                  if (modalvalue.fields[0] === location.servers[i].name) {
                    pass = false;
                    break;
                  }
                }
                if (modalvalue.button === "cancel") {
                  modal.destroy();
                } else if (modalvalue.fields[0] !== "" && pass) {
                  // const servers = location.servers;
                  location.servers.push({
                    id: location.servers.length,
                    name: modalvalue.fields[0],
                  });
                  let hit = false;
                  for (let i = 0; i < assignments.length; ++i) {
                    if (assignments[i].section == result.value) {
                      hit = true;
                      assignments[i].server = modalvalue.fields[0];
                    }
                  }
                  if (!hit) {
                    assignments.push({
                      // id: assignments.length + 1,
                      section: result.value,
                      server: modalvalue.fields[0],
                    });
                  }
                  const proposed = {
                    domain: "location",
                    _id: location._id,
                    servers: location.servers,
                    assignments,
                  };
                  kd.update(proposed)
                    .then((result3) => {
                      modal.destroy();
                    })
                    .catch((err4) => {
                      console.log("err4", err4);
                    });
                } else {
                  const opt5 = {
                    position: "top",
                    width: "90%",
                    seconds: 3,
                    h1: l.translate("Server name already exists"),
                    body: l.translate("Please choose a unique server name."),
                    buttons: [
                      {
                        description: "ok",
                        value: "close",
                      },
                    ],
                  };
                  notification.create(opt5, {}, (notificationerr, value2) => {
                    notification.destroy();
                  });
                }
              });
            } else if (result2.value == "clear") {
              for (let i = 0; i < assignments.length; ++i) {
                if (assignments[i].section == opt2.section) {
                  assignments.splice(i, 1);
                  break;
                }
              }
            } else {
              let hit = false;
              for (let i = 0; i < assignments.length; ++i) {
                if (assignments[i].section == result.value) {
                  hit = true;
                  assignments[i].server = result2.value;
                }
              }
              if (!hit) {
                assignments.push({
                  // id: assignments.length + 1,
                  section: result.value,
                  server: result2.value,
                });
              }
            }
            const proposed = {
              domain: "location",
              _id: kd.location._id,
              assignments,
            };
            kd.update(proposed)
              .then((result3) => {})
              .catch((err4) => {
                console.log("err4", err4);
              });
          });
          break;
        }
        case "disable": {
          templatedata.tables.forEach((template) => {
            if (template.section == result.value) {
              if (!location.disabledTables.includes(template.table)) {
                location.disabledTables.push(template.table);
              }
            }
          });

          const proposed = {
            domain: "location",
            _id: kd.location._id,
            _kd: {
              mergerule: "REPLACE",
            },
            disabledTables: location.disabledTables,
          };
          kd.update(proposed)
            .then((result4) => {})
            .catch((err3) => {
              console.log("err3", err3);
            });
          break;
        }
        case "enable": {
          for (let i = 0; i < templatedata.tables.length; ++i) {
            if (templatedata.tables[i].section == result.value) {
              for (let t = 0; t < location.disabledTables.length; ++t) {
                if (
                  location.disabledTables[t] == templatedata.tables[i].table
                ) {
                  location.disabledTables.splice(t, 1);
                  break;
                }
              }
            }
          }

          const proposed = {
            domain: "location",
            _id: kd.location._id,
            _kd: {
              mergerule: "REPLACE",
            },
            disabledTables: location.disabledTables,
          };
          kd.update(proposed)
            .then((result5) => {})
            .catch((err5) => {
              console.log("err5", err5);
            });
          break;
        }
        case "zoom": {
          const opt3 = {
            section: result.value,
          };
          chart.zoom(kd, opt3);
          break;
        }
        default:
          break;
      }
    });
  });
};

module.exports = {
  init,
};



/** WEBPACK FOOTER **
 ** ./src/controllers/sections/index.js
 **/